<div class="chart-header">
  <div class="pager">
    <button class="nav" (click)="prevPage()" [disabled]="!canPrev">‹ {{ 'previous_7_days' | translate }}</button>
    <button class="nav" (click)="nextPage()" [disabled]="!canNext">{{ 'next_7_days' | translate }} ›</button>
  </div>
</div>

<div class="chart-wrap">
  @if (!hasData) {
    <div class="empty">{{ 'no_data' | translate }}</div>
  }
  <div #chartEl id="advertStatisticsChart" [class.hidden]="!hasData"></div>
</div>
